import { render, staticRenderFns } from "./page-item.vue?vue&type=template&id=07e0cb2a&"
import script from "./page-item.vue?vue&type=script&lang=ts&"
export * from "./page-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports